import React from 'react';

const FiveColumnGrid = ({ children }) => (
  <div className="grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-4">
    {children}
  </div>
);

export default FiveColumnGrid;
